import axios from 'axios';
import React from 'react'
import './updateDP.css'

class UpdateDP extends React.Component {
  constructor(props){
    super(props);
    this.state = {organizer: '', location: '', startDate: '', startTime: '', endDate: '', endTime: ''};
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const urlPathname = window.location.pathname
    const urlID = urlPathname.split('/')
    axios.get('https://blood147.000webhostapp.com/admin_panel/selectDonationPrograms.php/?id=' + urlID[2])
    .then(response => response.data)
    .then((data) => {
      // handle success
      data.map(program => {
        const start = program.startDateTime.split(/(\s+)/)
        const end = program.endDateTime.split(/(\s+)/)
        this.setState({ organizer: program.organizer, location: program.location, startDate: start[0], startTime: start[2], endDate: end[0], endTime: end[2]})
      })
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    })
    .then(function () {
      // always executed
    });
  }

  handleChange(e){
    const state = this.state
    state[e.target.name] = e.target.value
    this.setState(state);
  }

  handleSubmit(e){
    e.preventDefault()

    const checkOrganizer = document.getElementById('organizer').value
    const checkLocation = document.getElementById('location').value
    const checkStartDate = document.getElementById('startDate').value
    const checkStartTime = document.getElementById('startTime').value
    const checkEndDate = document.getElementById('endDate').value
    const checkEndTime = document.getElementById('endTime').value

    if(checkOrganizer == '' || checkLocation == '' || checkStartDate == '' || checkStartTime == '' || checkEndDate == '' || checkEndTime == ''){
      document.getElementById('errorOrganizer').style.display = 'block'
      document.getElementById('errorLocation').style.display = 'block'
      document.getElementById('errorStartDate').style.display = 'block'
      document.getElementById('errorStartTime').style.display = 'block'
      document.getElementById('errorEndDate').style.display = 'block'
      document.getElementById('errorEndTime').style.display = 'block'
      return
    }
    else{
      document.getElementById('errorOrganizer').style.display = 'none'
      document.getElementById('errorLocation').style.display = 'none'
      document.getElementById('errorStartDate').style.display = 'none'
      document.getElementById('errorStartTime').style.display = 'none'
      document.getElementById('errorEndDate').style.display = 'none'
      document.getElementById('errorEndTime').style.display = 'none'
    }

    this.update();
  }

  update(){
    const urlPathname = window.location.pathname
    const urlID = urlPathname.split('/')

    let formData = new FormData();
    formData.append('organizer', this.state.organizer)
    formData.append('location', this.state.location)
    formData.append('startDateTime', this.state.startDate + ' ' + this.state.startTime)
    formData.append('endDateTime', this.state.endDate + ' ' + this.state.endTime)
    
    axios({
        method: 'post',
        url: 'https://blood147.000webhostapp.com/admin_panel/updateDonationPrograms.php?id=' + urlID[2],
        data: formData,
        config: { headers: {'Content-Type': 'multipart/form-data' }}
    })
    .then(function (response) {
        if(response.data == 'failed'){
          alert('Update failed!!!\nRecheck your entries.\nMaybe try again later.')
        }
        else{
          alert('Update successful!!!')
          window.history.go(-1)
        }  
    })
    .catch(function (response) {
        //handle error
        console.log(response)
    });
  }

  render(){
    return (
      <div className="updateDP">
        <div className="updateDPContainer">
          <form className="updateDPForm">
            <div className="updateDPFormDiv">
              <div className="updateDPInputWrapper">
                <label htmlFor="organizer" className='updateDPLabel'>Organizer:</label>
                <p id='errorOrganizer' className='errorMessage'>Please fill in organizer's name!</p>
                <input id='organizer' type="text" className="updateDPInput" placeholder="Red Cross Society" name="organizer" value={this.state.organizer} onChange={this.handleChange}/> 
              </div>
              <div className="updateDPInputWrapper">
                <label htmlFor="location" className='updateDPLabel'>Location:</label>
                <p id='errorLocation' className='errorMessage'>Please fill the event location!</p>
                <input id='location' type="text" className="updateDPInput" placeholder="Street, City, Country" name="location" value={this.state.location} onChange={this.handleChange}/> 
              </div>
            </div>

            <div className="updateDPFormDiv">
              <div className="updateDPInputWrapper">
                <label htmlFor="startDate" className='updateDPLabel'>Start Date:</label>
                <p id='errorStartDate' className='errorMessage'>Please select start date!</p>
                <input id='startDate' type="date" className="updateDPInput" name="startDate" value={this.state.startDate} onChange={this.handleChange}/> 
              </div>
              <div className="updateDPInputWrapper">
                <label htmlFor="startTime" className='updateDPLabel'>Start Time:</label>
                <p id='errorStartTime' className='errorMessage'>Please select start time!</p>
                <input id='startTime' type="time" className="updateDPInput" name="startTime" value={this.state.startTime} onChange={this.handleChange}/> 
              </div>
            </div>

            <div className="updateDPFormDiv">
              <div className="updateDPInputWrapper">
                <label htmlFor="endDate" className='updateDPLabel'>End Date:</label>
                <p id='errorEndDate' className='errorMessage'>Please select end date!</p>
                <input id='endDate' type="date" className="updateDPInput" name="endDate" value={this.state.endDate} onChange={this.handleChange}/> 
              </div>
              <div className="updateDPInputWrapper">
                <label htmlFor="endTime" className='updateDPLabel'>End Time:</label>
                <p id='errorEndTime' className='errorMessage'>Please select end time!</p>
                <input id='endTime' type="time" className="updateDPInput" name="endTime" value={this.state.endTime} onChange={this.handleChange}/> 
              </div>
            </div>

            <div className="updateDPFormDiv">
              <div className="updateDPSubmitWrapper">
                <input type="submit" className='updateDPSubmit' onClick={this.handleSubmit} value="Update" />
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default UpdateDP